export const resolveKeysInObjectsArrays = (p, o) => {
  const reducerFunction = (xs, x) => {
      return xs && xs[x] ? xs[x] : null
  }
  return p.reduce(reducerFunction, o)
}


export const appPrefix = (() => {
  let langPrefix = ''
  let lang = 'en'
  // const LOCAL_LANG = process.env.LOCALE_LANG
  // const ENGLISH_LANG = 'en'

  const pathname = resolveKeysInObjectsArrays(['location', 'pathname'], window)

  const [, ln = lang] = (pathname || '').split('/')

  if (ln === 'ar') {
      langPrefix = '/ar'
      lang = ln
  }

  return ln === 'ar' ? `${langPrefix}` : ''
})()
